const DateTimeFieldMixins = {
  computed: {
    viewMode: function() {
      if (this.field.settings?.input_type === 'time') {
        return 'time';
      } else {
        return 'date';
      }
    },

    viewChangable: function() {
      return this.field.settings?.input_type === 'datetime-local';
    },

    format: function() {
      switch (this.field.settings.input_type) {
        case 'time':
          return 'hh:mm';
        case 'date':
          return 'YYYY-MM-DD';
        default:
          return 'YYYY-MM-DD hh:mm';
      }
    }
  },

  methods: {
    _stringfy: function(date) {
      if (date) {
        return date.strftime(this.format);
      } else {
        return '';
      }
    },

    _parseValue: function(str) {
      return Date.parseFromString(str);
    }
  }
};

export default DateTimeFieldMixins;
